<template>
    <div v-if="participants.length > 0">

        <notifications :show="['participant']"></notifications>

        <participant-block v-for="participant in participants" v-if="participant" :key="participant.id" :alert="alerts.indexOf(participant.id) > -1" :participant="participant" @removed="refresh" @alert="alert = true"></participant-block>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else-if="loading">
        <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                loading: true,
                alert: false,

                participants: [],
                alerts: [],
            }
        },
        components: {
            'participant-block': require('./ChildBlock.vue'),
            'notifications': require('../Notifications.vue')
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.children;
            }
        },
        methods: {
            refresh: function () {

                /**Checking if the user is currently logged in**/
                axios.get('/camp-booking/users/current')
                    .then(response => {
                        if(response.data.data.user_id == null) {
                            this.$router.push({name: 'auth.login'});
                            return false;
                        }
                    })

                this.alert = false;
                this.loading = true;
                /**
                 * Getting the payments
                 **/
                axios.get('/camp-booking/participants?load_attending_data=true')
                    .then(response => {
                        if(response.data.data.length > 0)
                            this.participants = response.data.data.sort(function(a,b) {return (a.first_name.toLowerCase() > b.first_name.toLowerCase()) ? 1 : ((b.last_name.toLowerCase() > a.last_name.toLowerCase()) ? -1 : 0);} );
                        else
                            this.$root.alert(this.locale.text_children_empty, 'danger', false, true, true);
                        this.loading = false;
                    })

                /**
                 * Checking whether any of the children have a notification against them
                 */
                axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/notifications')
                    .then(response => {
                        response.data.data.forEach(notification => {
                            if(notification.type == 'participant')
                                this.alerts.push(notification.id);
                        })
                    });
            },
            currencyFormat: function ( value ) {
                return '£' + Math.abs(value).toFixed(2);
            },
        },
        created () {
            this.refresh();

            /**
             * Setting the headers
             */
            this.$root.headers = {
                navigate: {
                    name: 'account.overview'
                },
                title: this.$root.locale.miscellaneous.page_headings.account.view_all_children
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Children.vue?2c7ad178